module.exports = __webpack_public_path__ + "static/29th-1b1bddc7df99029fcf2925932cc8859d.png";